<template>
  <layout>
    <div slot="banner"></div>
    <div class="rule">
      <section class="track-entry">
        <div class="layout-content">
          <div class="entry-copy">
            <h1>{{ isEnLang ? 'Competition Rules' : '参赛规则' }}</h1>
            <p>{{ isEnLang ? 'Select a track to view eligibility, registration and competition procedures.' : '请选择对应赛道查看报名要求与参赛流程' }}</p>
          </div>

          <div v-if="tracks.length > 1" class="track-switch" role="tablist" :aria-label="isEnLang ? 'Track selection' : '赛道区域切换'">
            <button
              v-for="track in tracks"
              :key="track.value"
              class="track-option"
              :class="{ active: activeTrack === track.value }"
              role="tab"
              :aria-selected="activeTrack === track.value"
              @click="activeTrack = track.value"
            >
              <strong>{{ track.title }}</strong>
              <small>{{ track.en }}</small>
            </button>
          </div>

          <div v-if="activeTrack === 'international' && !isEnLang" class="language-switch" aria-label="国际赛道语言版本">
            <button :class="{ active: internationalLanguage === 'zh' }" @click="internationalLanguage = 'zh'">中文参考</button>
            <button :class="{ active: internationalLanguage === 'en' }" @click="internationalLanguage = 'en'">English</button>
          </div>
        </div>
      </section>

      <!-- 报名规则 -->
      <RegistrationRules :data="info.applyRule" :track="activeTrack" :language="internationalLanguage" />

      <!-- 参赛流程 -->
      <Process :data="info.process" :track="activeTrack" :language="internationalLanguage" />

      <!-- 评审规则 -->
      <ReviewRule :track="activeTrack" :language="internationalLanguage" />

      <!-- 十家实习单位 -->
      <!-- <PracticeUnit :data="info.unit" /> -->

      <!-- 参赛注意事项 -->
      <CompetitionStatement :track="activeTrack" :language="internationalLanguage" />
    </div>
  </layout>
</template>

<script>
import layout from '@/components/layout/layout'

import RegistrationRules from './RegistrationRules.vue'
import Process from './Process.vue'
import ReviewRule from './ReviewRule.vue'
// import PracticeUnit from './PracticeUnit.vue'
import CompetitionStatement from './CompetitionStatement'
import { mapState } from 'vuex'

export default {
  name: 'CompetitionRulePage',
  data () {
    return {
      activeTrack: 'domestic',
      internationalLanguage: 'zh'
    }
  },
  components: {
    layout,
    RegistrationRules,
    Process,
    ReviewRule,
    CompetitionStatement
    // PracticeUnit
  },
  created () {
    if (this.isEnLang) {
      this.activeTrack = 'domestic'
      this.internationalLanguage = 'en'
    }
  },
  watch: {
    isEnLang (enabled) {
      if (enabled) {
        this.activeTrack = 'domestic'
        this.internationalLanguage = 'en'
      }
    }
  },
  computed: {
    ...mapState(['isEnLang']),
    tracks () {
      return this.isEnLang
        ? [
            { value: 'domestic', index: '01', title: 'Domestic Tracks', en: 'AI & DATA ANALYTICS' },
            { value: 'international', index: '02', title: 'International Track', en: 'GLOBAL AI' }
          ]
        : [
            { value: 'domestic', index: '01', title: '国内赛道', en: 'DOMESTIC TRACK' },
            { value: 'international', index: '02', title: '国际赛道', en: 'INTERNATIONAL TRACK' }
          ]
    },
    info () {
      return this.$t('rule')
    }
  }
}
</script>
<style lang="scss" scoped>
.rule {
  padding-top: 66px;
  background: #f5f6f8;

  @include mobile {
    padding-top: 0;
  }
}

.track-entry {
  padding: 64px 0 42px;
  text-align: center;
  background: #fff;
  border-bottom: 1px solid #eceef1;
}

.entry-copy h1 { margin-bottom: 10px; color: #15171b; font-size: 36px; line-height: 1.2; font-weight: 600; }
.entry-copy p { color: #8a9099; font-size: 14px; }

.track-switch {
  display: inline-flex;
  margin-top: 30px;
  padding: 4px;
  border-radius: 4px;
  background: #f1f2f4;
}
.track-option {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 190px;
  justify-content: center;
  padding: 12px 22px;
  border: 0;
  color: #777e88;
  background: transparent;
  cursor: pointer;
  transition: .2s ease;
}
.track-option:hover { color: #24282f; }
.track-option.active { color: #111827; background: #fff; box-shadow: 0 2px 8px rgba(25,33,46,.08); }
.track-option strong { font-size: 15px; font-weight: 500; }
.track-option small { color: #a1a6ad; font-size: 9px; letter-spacing: .6px; }
.language-switch { display: flex; justify-content: center; gap: 16px; margin-top: 18px; }
.language-switch button { padding: 4px 2px; border: 0; border-bottom: 1px solid transparent; color: #9a9fa7; font-size: 12px; background: transparent; cursor: pointer; }
.language-switch button.active { color: #d64943; border-bottom-color: #d64943; }

.pending-section { padding: 90px 0 110px; background: #fff; }
.pending-heading { display: flex; align-items: center; gap: 16px; margin-bottom: 34px; }
.pending-heading > span { color: #dc4d47; font-size: 12px; font-weight: 700; }
.pending-heading p { margin-bottom: 5px; color: #9aa1ad; font-size: 10px; letter-spacing: 1.6px; }
.pending-heading h2 { font-size: 30px; font-weight: 600; }
.pending-card { display: flex; align-items: center; min-height: 170px; padding: 38px; border: 1px dashed #cdd3dc; background: #fafbfc; }
.pending-mark { display: grid; place-items: center; width: 54px; height: 54px; margin-right: 24px; border: 1px solid #d5dae2; color: #aab1bd; font-size: 26px; }
.pending-card strong { font-size: 18px; }
.pending-card p { margin-top: 10px; color: #8a929e; font-size: 14px; }

@include mobile {
  .rule { padding-top: 54px; }
  .track-entry { padding: 40px 0 30px; }
  .entry-copy h1 { font-size: 28px; }
  .entry-copy p { font-size: 13px; line-height: 22px; }
  .track-switch { display: flex; width: 100%; margin-top: 24px; }
  .track-option { flex: 1; min-width: 0; padding: 11px 8px; }
  .track-option small { display: none; }
  .pending-section { padding: 54px 0; }
  .pending-heading h2 { font-size: 24px; }
  .pending-card { align-items: flex-start; padding: 25px 20px; }
  .pending-mark { flex: none; width: 42px; height: 42px; margin-right: 16px; }
}
</style>
